import { render } from "./Reload.vue?vue&type=template&id=45aa9e60&scoped=true"
import script from "./Reload.vue?vue&type=script&lang=js"
export * from "./Reload.vue?vue&type=script&lang=js"

import "./Reload.vue?vue&type=style&index=0&id=45aa9e60&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45aa9e60"]])

export default __exports__